import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Stepper, Step, StepLabel, Grid, Typography, Divider, Box } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import { EditorGenerico } from 'views/ExamesRealizados/components/EditorGenerico/EditorGenerico'
import { Quesitos } from 'views/ExamesRealizados/components/Quesitos'
import { CustomButton } from 'components'
import { ListaLocais } from './components/ListaLocais'
import { useFormExameLocal } from './hooks/useFormExameLocal'
import { useStyles } from './Form.styles'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import SaveIcon from '@material-ui/icons/Save'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

const steps = ['Locais examinados', 'Discussão', 'Conclusão', 'Quesitos']

export const Form = (props) => {
  const classes = useStyles()
  const router = useRouter()
  const { carregando, idExameSolicitado, exameLocal, setExameLocal, processandoExameLocal, setProcessandoExameLocal, idExameRealizado } = props

  const {
    activeStep,
    titleList,
    setTitleList,
    hideNextButton,
    setHideNextButton,
    setFormLocaisErro,
    formDiscussao,
    formConclusao,
    formQuesitos,
    handleBack,
    handleNext,
    formError,
  } = useFormExameLocal({
    exameLocal,
    setExameLocal,
    setProcessandoExameLocal,
    processandoExameLocal,
  })

  const Title = () => (
    <Typography className={classes.title}>
      {titleList.map((title, index) => `${title} ${index === titleList.length - 1 ? '' : ' / '} `)}
    </Typography>
  )

  const getStepTitle = () => {
    switch (activeStep) {
      case 0:
        return <Title />
      case 1:
        return <Typography className={classes.title}>Discussão</Typography>
      case 2:
        return <Typography className={classes.title}>Conclusão</Typography>
      case 3:
        return <Typography className={classes.title}>Quesitos</Typography>
      default:
        return ''
    }
  }

  return (
    <Box>
      {carregando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Box>
          <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Grid container justify="space-between" spacing={1}>
            <Grid item md={12} sm={12} xs={12}>
              <Typography component="h4" variant="h4">
                {getStepTitle()}
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Divider style={{ margin: '16px 0' }} />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              {activeStep === 0 && (
                <ListaLocais
                  setFormLocaisErro={setFormLocaisErro}
                  titleList={titleList}
                  setTitleList={setTitleList}
                  idExameSolicitado={idExameSolicitado}
                  setHideNextButton={setHideNextButton}
                  idExameRealizado={idExameRealizado}
                />
              )}
              {activeStep === 1 && (
                <EditorGenerico
                  formState={formDiscussao.formState}
                  tituloCampoTexto="Corpo da discussão"
                  setFormState={formDiscussao.setFormState}
                  processandoExame={processandoExameLocal}
                  exame={exameLocal}
                  campo="discussao"
                />
              )}
              {activeStep === 2 && (
                <EditorGenerico
                  formState={formConclusao.formState}
                  tituloCampoTexto="Corpo da discussão"
                  setFormState={formConclusao.setFormState}
                  processandoExame={processandoExameLocal}
                  exame={exameLocal}
                  campo="conclusao"
                />
              )}
              {activeStep === 3 && (
                <Quesitos
                  formState={formQuesitos.formState}
                  setFormState={formQuesitos.setFormState}
                  processandoExame={processandoExameLocal}
                  exame={exameLocal.exReal}
                />
              )}
              <Divider style={{ margin: '32px 0 16px 0' }} />
            </Grid>
            {!hideNextButton && (
              <Grid container justify="space-between" spacing={1} className={classes.buttons}>
                <Grid item>
                  {activeStep === 0 ? (
                    <CustomButton
                      variant="outlined"
                      onClick={() => router.history.goBack()}
                      startIcon={<ArrowBackIcon />}
                    >
                      Voltar
                    </CustomButton>
                  ) : (
                    <CustomButton
                      variant="outlined"
                      onClick={handleBack}
                      startIcon={<NavigateBeforeIcon />}
                    >
                      Etapa Anterior
                    </CustomButton>
                  )}
                </Grid>
                <Grid item>
                  <CustomButton
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    disabled={formError || processandoExameLocal}
                    startIcon={activeStep === steps.length - 1 ? <SaveIcon /> : <NavigateNextIcon />}
                  >
                    {activeStep === steps.length - 1 ? 'Finalizar formulário' : 'Próxima Etapa'}
                  </CustomButton>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </Box>
  )
}

Form.propTypes = {
  carregando: PropTypes.bool,
  idExameSolicitado: PropTypes.number.isRequired,
  exameLocal: PropTypes.object.isRequired,
  setExameLocal: PropTypes.func.isRequired,
  processandoExameLocal: PropTypes.bool.isRequired,
  setProcessandoExameLocal: PropTypes.func.isRequired,
  idExameRealizado: PropTypes.string.isRequired,
}

